import { Controller } from "@hotwired/stimulus"
import { closeHighlightModal, openHighlightModal, pauseHighlightPreview } from "../utils/highlight_modal"

export default class extends Controller {
  static targets = ["modal", "video", "source", "caption", "userName", "userAvatar", "profileLink", "reel", "serviceLink", "serviceTitle"]

  disconnect() {
    closeHighlightModal()
  }

  flag(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const modal = document.getElementById("reel-modal")
    const activeId = modal?.dataset?.activeId
    if (!activeId) {
      alert("Error: No content identified.")
      return
    }

    const globalModal = document.getElementById("global-report-modal")
    const typeInput = document.getElementById("report-flaggable-type")
    const idInput = document.getElementById("report-flaggable-id")

    if (globalModal && typeInput && idInput) {
      typeInput.value = "Highlight"
      idInput.value = activeId
      globalModal.classList.remove("hidden")
      globalModal.classList.add("flex")
    }
  }

  open(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const reel = event?.target?.closest("[data-highlight-id]") || event?.currentTarget?.closest?.("[data-highlight-id]")
    if (reel) openHighlightModal(reel)
  }

  close() {
    closeHighlightModal()
  }
}
